import VaccinesIcon from '@mui/icons-material/LocalAtm';
import { PriceList } from './Price.List';
import { PriceCreate } from './Price.Create';
import { PriceEdit } from './Price.Edit';
import { PriceUpload } from './Price.Upload';

export default {
    list: PriceList,
    create: PriceCreate,
    edit: PriceEdit,
    upload: PriceUpload,
    icon: VaccinesIcon,
};
